import { EMI } from 'shared/model/types';
import { RootState } from '../store';

export const getActivity = (state: RootState) => state.app.activity.isActive;
export const getActivitySilent = (state: RootState) => state.app.activity.silent;
// export const getCurrentBottomSheet = (state: RootState) => state.app.bottomSheet;
export const getSettings = (state: RootState) => state.app.settings;
export const getStateAppTheme = (state: RootState) => state.app.theme;
export const getCurrentEmi = (state: RootState) => state.app.currentEmi || EMI.Wallester;
export const getLanguage = (state: RootState) => state.app.language;
